import { createSlice } from '@reduxjs/toolkit';
import { todayUtc } from 'utils/dateTimeUtils';

const buildDefaultFilters = (userId = null) => ({
    day: todayUtc(),
    locationIds: null,
    accountIds: userId != null ? [userId] : null,
    searchTerm: '',
});

const initialState = {
    currentUserId: null,
    tableId: null,
    tableConfigName: null,
    filters: buildDefaultFilters(),
    filterOptions: { locations: [], accounts: [] },
    filterOptionsLoading: false,
    totalItems: 0,
    currentPage: 0,
    pageSize: 100,
    searchLoading: false,
};

const allEventsSlice = createSlice({
    name: 'allEvents',
    initialState,
    reducers: {
        initFilters(state, { payload: { userId, tableId = null, tableConfigName = null } }) {
            state.currentUserId = userId;
            state.tableId = tableId;
            state.tableConfigName = tableConfigName;
            state.filters = buildDefaultFilters(userId);
            state.currentPage = 0;
            state.totalItems = 0;
        },

        setDay(state, { payload: day }) {
            state.filters.day = day;
        },
        setLocationIds(state, { payload: locationIds }) {
            state.filters.locationIds = locationIds;
        },
        setAccountIds(state, { payload: accountIds }) {
            state.filters.accountIds = accountIds;
        },
        setSearchTerm(state, { payload: searchTerm }) {
            state.filters.searchTerm = searchTerm;
        },
        resetFilters(state) {
            state.filters = buildDefaultFilters(state.currentUserId);
            state.currentPage = 0;
            state.totalItems = 0;
        },
        // Full slice reset — used on page unmount so stale currentPage/totalItems
        // (and filters/options) don't leak into the next mount before the first search.
        resetAllEventsSlice() {
            return initialState;
        },
        setFilterOptions(state, { payload: { locations, accounts } }) {
            state.filterOptions = { locations, accounts };
        },
        setFilterOptionsLoading(state, { payload: loading }) {
            state.filterOptionsLoading = loading;
        },
        setTotalItems(state, { payload: totalItems }) {
            state.totalItems = totalItems;
        },
        setCurrentPage(state, { payload: page }) {
            state.currentPage = page;
        },
        setPageSize(state, { payload: size }) {
            state.pageSize = size;
            state.currentPage = 0;
        },
        setSearchLoading(state, { payload: loading }) {
            state.searchLoading = loading;
        },
        // saga triggers — no reducer logic needed
        fetchFilterOptionsStart() {},
        searchStart() {},
    },
});

export const allEventsActions = allEventsSlice.actions;
export const allEventsReducer = allEventsSlice.reducer;
